<ng-container *ngIf="isDialogOpened">
  <kendo-window [title]="windowTitle"
                [minWidth]="800"
                [width]="800"
                [minHeight]="780"
                (close)="cancel()"
                class="top-left-counter-card k-window-content min-height-150 confirm-dialog app-confirm-dialog kendo-window-with-titlebar">
    <div class="spacing-x-20" *ngIf="page == 1">
      <h3>{{ 'projectValuationCopyValuationPortfolioDialog.step1Title' | translate }}</h3>
      <p>{{ 'projectValuationCopyValuationPortfolioDialog.step1Description' | translate }}</p>
      <div class="grid-table">
        <kendo-grid #kendoGrid class="grid-v2 grouping-enabled copy-grid"
                    [pageable]="true"
                    [pageSize]="state.take"
                    [data]="selectedProperties"
                    [loading]="loading"
                    [skip]="state.skip"
                    [sortable]="true"
                    [sort]="state.sort"
                    [filterable]="true"
                    [resizable]="true"
                    [selectable]="selectableSettings"
                    [filter]="state.filter"
                    kendoGridSelectBy="Oid"
                    [(selectedKeys)]="selectedItems"
                    [columnMenu]="columnMenuSettings"
                    [reorderable]="true">
          <ng-template kendoGridColumnMenuTemplate let-service="service">
            <div class="grid-v2-column-menu">
              <kendo-grid-columnmenu-sort [service]="service">
              </kendo-grid-columnmenu-sort>
              <kendo-grid-columnmenu-chooser [service]="service">
              </kendo-grid-columnmenu-chooser>
              <kendo-grid-columnmenu-filter [service]="service">
              </kendo-grid-columnmenu-filter>
            </div>
          </ng-template>
          <kendo-grid-column *ngFor="let col of columns; trackBy: trackByField"
                             [field]="col.field"
                             [width]="col.width"
                             [title]="col.title | translate"
                             [columnMenu]="col.field !== 'checkbox'"
                             [class]="col.field === 'PublishStatusId' ? 'publish-status-field' : ''">
            <ng-template kendoGridHeaderTemplate *ngIf="col.field === 'checkbox'"
                         let-column
                         let-columnIndex="columnIndex">
              <input type="checkbox" id="checkAllValuationEventProperties" [(ngModel)]="checkAllChecked" (change)="selectOrDeselectAllCheckbox()" class="k-checkbox" /><label class="k-checkbox-label" for="checkAllValuationEventProperties"></label>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" *ngIf="col.field === 'checkbox'">
              <input type="checkbox" [(ngModel)]="dataItem.checkbox" [attr.id]="'gridCheckboxValuationEvent' + dataItem.Oid" class="gridCheckbox k-checkbox" /><label class="k-checkbox-label checkbox-centering" [attr.for]="'gridCheckboxValuationEvent' + dataItem.Oid"></label>
            </ng-template>

          </kendo-grid-column>
        </kendo-grid>
      </div>
    </div>
    <div class="dialogContainer" *ngIf="page == 2 || page == 3">
      <h3 *ngIf="page == 2">{{ 'projectValuationCopyValuationPortfolioDialog.step2Title' | translate }}</h3>
      <p *ngIf="page == 2">{{ 'projectValuationCopyValuationPortfolioDialog.step2Description' | translate }}</p>
      <h3 *ngIf="page == 3">{{ 'projectValuationCopyValuationPortfolioDialog.step3Title' | translate }}</h3>
      <p *ngIf="page == 3 && !copying">{{ 'projectValuationCopyValuationPortfolioDialog.step3Description' | translate }}</p>
      <p *ngIf="page == 3 && copying">{{ 'projectValuationCopyValuationPortfolioDialog.step3CopyingDescription' | translate }}</p>
      <copy-valuation-event-form [form]="formData"
                                 [readonly]="page == 3"
                                 [periodofvaluation]="reflistData.ref_valuation_project_periodofvaluation"
                                 [copyValuationPortfolioData]="copyValuationPortfolioData"
                                 [originalValuationPortfolioData]="originalValuationPortfolioData"
                                 (enableSaveOnPortfolioData)="enableNextOnPortfolioData($event)"
                                 [propertiesCount]="selectedProperties.length"
                                 [availableValuationPeriods]="availableValuationPeriods"></copy-valuation-event-form>
    </div>

    <div *ngIf="page == 4" style="width: 100%; height: calc(100% - 45px)">
      <h3>{{ 'projectValuationCopyValuationPortfolioDialog.step5Title' | translate }}</h3>
      <p>{{ 'projectValuationCopyValuationPortfolioDialog.step5SuccessDescription' | translate }}</p>
    </div>
    <div class="dialogButtonBar">
      <div class="ProjectTasksDashboardButtonBarBorder"></div>
      <div class="ButtonBar">
        <button class="k-button" (click)="cancel()">{{ 'projectValuationCopyValuationPortfolioDialog.cancel' | translate }}</button>
        <button class="k-button" (click)="back()" [disabled]="page == 1">{{ 'projectValuationCopyValuationPortfolioDialog.back' | translate }}</button>
        <button *ngIf="page != 3" class="k-button" (click)="next()" [disabled]="!enableSaveOnPortfolioData && page == 2">{{ 'projectValuationCopyValuationPortfolioDialog.next' | translate }}</button>
        <button *ngIf="page == 3" class="k-button" (click)="confirm()">{{ 'projectValuationCopyValuationPortfolioDialog.confirm' | translate }}</button>
      </div>
    </div>
  </kendo-window>
  <div class="k-overlay overlay-confirm-dialog"></div>
</ng-container>
